import React from 'react'
import {AvatarName} from '../../utils/Validate'

const Avatar = (props) => {
    const {preName} = props
    function generateStableColor(value) {
        const palette = ["#005795", "#2563eb", "#4f46e5", "#0891b2", "#16a34a", "#ca8a04", "#dc2626", "#7c3aed"];
        const input = value || "";
        const hash = input.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
        return palette[hash % palette.length];
    }
      
    return (
        <div className="avatar mr-2" style={{backgroundColor:generateStableColor(preName)}}>{AvatarName(preName)}</div>
    )
}

export default Avatar
